import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../theme/AppTheme";
//import { useToast } from "@chakra-ui/react";

export default function useCustomFetch() {
	const authCtx = useContext(AuthContext);
	const themeCtx = useContext(ThemeContext);
	const navigate = useNavigate()
	//const toast = useToast()

	const fetcher = async (url: string, options: any) => {
		options.headers && (options.headers.Authorization = `Bearer ${authCtx.token}`)

		try {
			const res = await fetch(url, options);

			if (res.status === 401) {
				console.log(url, 'Unauthorized')
				authCtx.onLogout()
				navigate("/");
			} else {
				//console.log(url, 'Authorized')
				if(res.status === 404){ // #POW-81
					themeCtx.setShowFailure('networking.error')
				}
			}
	
			return res;
		} catch (error){
			console.log(url, 'Network error', error)
			themeCtx.setShowFailure('networking.error')
            return new Response(null, {
                status: 500,
                statusText: 'Network Error'
            });
		}
		
	};

	return fetcher;
}